import { render, staticRenderFns } from "./OverseasProjects.vue?vue&type=template&id=66313838&"
import script from "./OverseasProjects.vue?vue&type=script&lang=js&"
export * from "./OverseasProjects.vue?vue&type=script&lang=js&"
import style0 from "./OverseasProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports